import { combineReducers } from 'redux';

import { SELECT_DEALER } from 'constants/ActionTypes';
import * as types from 'modules/devices/actionTypes';
import { FETCH_DEVICES_REQUEST } from 'modules/devices/actionTypes';
import type { Action } from 'modules/global/generic.types';
import createHasMoreReducer from 'modules/global/reducers/generic.hasMore';
import ids from 'modules/global/reducers/generic.ids';
import createPageReducer from 'modules/global/reducers/generic.page';

import actions from './actions/index';
import appVersions from './appVersions';
import createdDevice from './createdDevice';
import creationModal from './creationModal';
import filters from './filters';
import osVersions from './osVersions';
import sendByEmail from './sendByEmail';

const matcher = { global: { matcher: ({ meta }: Action) => meta?.source === 'dashboard' } };

const idsCleanerMatcher = {
  matcher: ({ type }: Action) =>
    [types.CLEAN_DEVICES, types.CLEAR_FILTER, types.SET_FILTER, SELECT_DEALER].includes(type),
  reducer: () => [] as string[],
};

export default combineReducers({
  // Global reducers
  page: createPageReducer(FETCH_DEVICES_REQUEST, matcher),
  hasNext: createHasMoreReducer(FETCH_DEVICES_REQUEST, matcher),
  deviceIds: ids(FETCH_DEVICES_REQUEST, { matchers: [idsCleanerMatcher] }),
  // Specific reducers
  actions,
  filters,
  sendByEmail,
  createdDevice,
  creationModal,
  appVersions,
  osVersions,
});
